/**
 * Defines a serializer for numbers and bigints.
 * @category Serializers
 */

/**
 * Defines the options for u8 and i8 serializers.
 * @category Serializers
 */

/**
 * Defines the options for number serializers that use more than one byte.
 * @category Serializers
 */

/**
 * Defines the endianness of a number serializer.
 * @category Serializers
 */
let Endian;
(function (Endian) {
  Endian["Little"] = "le";
  Endian["Big"] = "be";
})(Endian || (Endian = {}));

export { Endian };
//# sourceMappingURL=common.mjs.map
